import { render, staticRenderFns } from "./RightMenuContent.vue?vue&type=template&id=35703fa8&scoped=true"
import script from "./RightMenuContent.vue?vue&type=script&lang=js"
export * from "./RightMenuContent.vue?vue&type=script&lang=js"
import style0 from "./RightMenuContent.vue?vue&type=style&index=0&id=35703fa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35703fa8",
  null
  
)

export default component.exports